import { IconAlertSquareRoundedFilled } from "@tabler/icons-react";
import { Modal, Flex, Button, Alert, Form, Input } from "antd";

export default function DeleteModal({
  isOpen,
  setIsOpen,
  onDelete,
  loading,
}: {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  onDelete: (forceDelete?: boolean) => void | Promise<void>;
  loading: boolean;
}) {
  const [form] = Form.useForm();

  const handleClose = () => {
    if (loading) return;
    setIsOpen(false);
    form.resetFields();
  };

  return (
    <>
      <Modal
        open={isOpen}
        closable={false}
        footer={null}
        destroyOnClose
        onCancel={handleClose}
        maskClosable={!loading}
      >
        <Flex gap={10} vertical justify="flex-start">
          <div>
            <Flex
              align="center"
              gap={4}
              className="mb-[16px!important] text-[#cc0000]"
            >
              <IconAlertSquareRoundedFilled size={24} />
              <h3 className="text-2xl font-semibold ff-title">
                This event has registrations
              </h3>
            </Flex>
            <Alert
              type="warning"
              message="Deleting this event will automatically initiate a refund to all
              registered customers."
            />
          </div>
          <Form
            form={form}
            layout="vertical"
            onFinish={async () => {
              await onDelete(true);
            }}
          >
            <Form.Item
              label="Write 'Delete' in the below input to delete the event"
              name="confirm"
              rules={[
                {
                  required: true,
                  message: "Writing 'Delete' is required",
                },
                {
                  validator: (_, value) => {
                    if (/^delete$/i.test(value)) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error('Value must be "Delete" (case-insensitive)')
                    );
                  },
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item noStyle>
              <Flex justify="flex-end" gap={16}>
                <Button
                  danger
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                >
                  I'm sure, delete
                </Button>
                <Button onClick={handleClose} disabled={loading}>
                  No, don't delete
                </Button>
              </Flex>
            </Form.Item>
          </Form>
        </Flex>
      </Modal>
    </>
  );
}
